exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".info-feedback---2azim{position:relative;padding-right:20px;z-index:100}.info-feedback---2azim .btn-info---VYpQs{width:48px;height:48px}.info-feedback---2azim .btn-info---VYpQs.btn-info-active---13GrD .info-icon-btn .isvg path{fill:#fd7849 !important}.info-feedback---2azim .user-feedback---1j4sO{position:absolute;left:48px;top:-80px;transition:left .5s;z-index:-1;visibility:hidden}@media only screen and (max-width: 1200px){.info-feedback---2azim .user-feedback---1j4sO{top:-110px}}.info-feedback---2azim .user-feedback-active---11f-B{left:141px;visibility:visible}@media only screen and (max-width: 1200px){.info-feedback---2azim .user-feedback-active---11f-B{left:111px}}.info-feedback---2azim .feedback-comment{width:260px}", ""]);

// exports
exports.locals = {
	"info-feedback": "info-feedback---2azim",
	"btn-info": "btn-info---VYpQs",
	"btn-info-active": "btn-info-active---13GrD",
	"user-feedback": "user-feedback---1j4sO",
	"user-feedback-active": "user-feedback-active---11f-B"
};